import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTypeOfProperty,
  getLocationList,
  getQuestionsList,
  submitSiteRoadwaysROW,
  utilityCrossingList,
} from "../../services/apiEndPoints";
import { GetQuestionsListPayload } from "../../types";

export const getQuestionsListThunk = createAsyncThunk(
  "access/getQuestionsList",
  async (payload: GetQuestionsListPayload) => {
    try {
      const response = await getQuestionsList(
        payload.category_id,
        payload.location_id
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getTypeOfLocationThunk = createAsyncThunk(
  "access/getTypeOfLocation",
  async (payload: GetQuestionsListPayload) => {
    try {
      const response = await getQuestionsList(
        payload.category_id,
        payload.location_id
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const submitSiteRoadwaysROWThunk = createAsyncThunk(
  "access/submitSiteRoadwaysROW",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitSiteRoadwaysROW(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const utilityCrossingListThunk = createAsyncThunk(
  "access/utilityCrossingList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await utilityCrossingList();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
